export default {
  computed: {
    showDivider() {
      return (index, collection) => collection && index !== (collection.length - 1);
    },
  },
};
